export default {"src":"/_next/static/media/app-store_badge_ja.206044d7.svg","height":40,"width":109,"blurWidth":0,"blurHeight":0};